<section id="evidencias" class="space-y-32 bg-surface py-24 lg:space-y-40 lg:py-32">
  @for (module of modules; track module.eyebrow; let index = $index; let even = $even) {
    <div class="site-container grid grid-cols-1 items-center gap-16 lg:grid-cols-2 lg:gap-24">
      <div class="space-y-8" [class]="even ? 'lg:order-2' : ''">
        <span class="text-xs font-black tracking-[0.3em] text-gold uppercase">{{ module.eyebrow }}</span>
        <h3 class="text-3xl leading-tight font-bold lg:text-4xl">{{ module.title }}</h3>
        <p class="text-lg leading-relaxed text-muted">{{ module.description }}</p>
        <ol class="space-y-4">
          @for (item of module.items; track item; let i = $index) {
            <li class="flex gap-4">
              <span class="flex size-6 shrink-0 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-white">
                0{{ i + 1 }}
              </span>
              <p class="font-bold text-primary">{{ item }}</p>
            </li>
          }
        </ol>
      </div>

      <!-- Mockups com dados fictícios -->
      <div aria-hidden="true" [class]="even ? 'lg:order-1' : ''">
        @switch (index) {
          @case (0) {
            <div class="relative mx-auto max-w-md">
              <div class="rounded-lg border border-line bg-canvas/60 p-8 shadow-xl">
                <div class="mb-6 flex items-start justify-between">
                  <div>
                    <p class="font-display font-bold text-primary">Dossiê do Profissional</p>
                    <p class="text-[10px] font-bold text-muted uppercase">ID: AUDIT-MED-0992</p>
                  </div>
                  <span class="rounded-full bg-primary px-3 py-1 text-[10px] font-bold text-white">VALIDADO</span>
                </div>
                <div class="space-y-4">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="flex h-24 flex-col justify-center gap-2 rounded border border-line bg-surface p-3 opacity-60">
                      <span class="h-2 w-1/2 rounded bg-primary/30"></span>
                      <span class="h-2 w-5/6 rounded bg-line"></span>
                      <span class="h-2 w-2/3 rounded bg-line"></span>
                      <span class="h-2 w-3/4 rounded bg-line"></span>
                    </div>
                    <div class="flex h-24 items-center justify-center rounded border border-line bg-surface">
                      <app-icon name="image" class="text-line" />
                    </div>
                  </div>
                  <div class="h-3 w-3/4 rounded bg-line/60"></div>
                  <div class="h-3 w-1/2 rounded bg-line/60"></div>
                  <div class="border-t border-line pt-4">
                    <p class="mb-2 text-[9px] font-black text-muted uppercase">Evidências de Credenciamento</p>
                    <div class="flex gap-2">
                      <span class="h-5 w-16 rounded-full border border-primary/20 bg-primary/10"></span>
                      <span class="h-5 w-20 rounded-full border border-primary/20 bg-primary/10"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="absolute -right-4 -bottom-6 hidden rounded-lg border border-gold/20 bg-primary p-6 text-white shadow-2xl md:block">
                <p class="mb-1 font-display text-3xl font-bold">98%</p>
                <p class="text-[10px] font-black tracking-widest uppercase opacity-70">Conformidade</p>
              </div>
            </div>
          }
          @case (1) {
            <div class="rounded-xl border border-line bg-canvas/60 p-8 shadow-xl">
              <p class="mb-6 text-[10px] font-black tracking-widest text-muted uppercase">Matriz de Desempenho - Unidade Central</p>
              <div class="flex aspect-video w-full items-end justify-between gap-2 border border-line/60 bg-surface px-4 pb-4">
                @for (bar of performance; track bar.label) {
                  <div class="w-full" [class]="[bar.height, bar.color]"></div>
                }
              </div>
              <div class="mt-6 flex justify-between text-[9px] font-black text-primary uppercase">
                @for (bar of performance; track bar.label) {
                  <span>{{ bar.label }}</span>
                }
              </div>
            </div>
          }
          @case (2) {
            <div class="space-y-6 rounded-xl border-b-4 border-gold bg-primary p-8 text-white shadow-2xl">
              <div class="flex items-center gap-4">
                <div class="flex size-12 items-center justify-center rounded border border-white/20 bg-white/10">
                  <app-icon name="verified_user" class="text-2xl text-gold" />
                </div>
                <p class="font-display text-lg font-bold">Aprovação de Privilégios</p>
              </div>
              <div class="space-y-4">
                <div class="flex items-center gap-4 rounded border border-white/10 bg-white/5 p-4">
                  <app-icon name="check_circle" class="text-gold" />
                  <div>
                    <p class="text-xs font-bold">Solicitação: Cirurgia Robótica</p>
                    <p class="text-[9px] font-black tracking-wider uppercase opacity-60">Dr. Eduardo Silva • 12 Out 2026</p>
                  </div>
                </div>
                <div class="ml-6 border-l border-gold/50 py-2 pl-4">
                  <span class="text-[10px] font-black tracking-widest text-gold uppercase">Aguardando Parecer Técnico</span>
                </div>
                <div class="flex items-center gap-4 rounded border border-white/10 bg-white/5 p-4 opacity-30">
                  <app-icon name="radio_button_unchecked" />
                  <div>
                    <p class="text-xs font-bold">Aprovação Direção Médica</p>
                    <p class="text-[9px] opacity-60">Pendente</p>
                  </div>
                </div>
              </div>
            </div>
          }
          @case (3) {
            <div class="mx-auto max-w-md space-y-6 rounded-xl border border-line bg-canvas/60 p-8 shadow-xl">
              <div>
                <p class="mb-4 text-[10px] font-black tracking-widest text-muted uppercase">Treinamentos obrigatórios</p>
                <div class="space-y-3">
                  @for (course of courses; track course.label) {
                    <div class="flex items-center gap-3">
                      <app-icon name="school" class="text-gold" />
                      <div class="min-w-0 flex-1">
                        <p class="mb-1 truncate text-xs font-bold text-primary">{{ course.label }}</p>
                        <div class="h-2 rounded-full bg-line/60">
                          <div class="h-full rounded-full bg-primary" [style.width.%]="course.progress"></div>
                        </div>
                      </div>
                      <span class="w-10 shrink-0 text-right text-xs font-bold text-primary">{{ course.progress }}%</span>
                    </div>
                  }
                </div>
              </div>
              <div class="border-t border-line pt-6">
                <p class="mb-4 text-[10px] font-black tracking-widest text-muted uppercase">Situação vacinal</p>
                <div class="grid grid-cols-3 gap-3 text-center">
                  @for (vaccine of vaccines; track vaccine.label) {
                    <div class="rounded border border-line bg-surface p-3">
                      <app-icon name="vaccines" [class]="vaccine.color" />
                      <p class="mt-1 text-[9px] font-black text-primary uppercase">{{ vaccine.label }}</p>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
</section>
